import { observer } from 'mobx-react-lite';
import * as React from 'react';
import CategoryKeywordModel from '../models/CategoryKeywordModel';
import AreasStep from '../components/AreasStep';
import KeywordsStep from '../components/KeywordsStep';
import ActivitiesStep from '../components/ActivitiesStep';
import ActivityAreasStep from '../components/ActivityAreasStep';
import KeywordsActivityAreasStep from '../components/KeywordsActivityAreasStep';
interface FCProps {}

const StepRender: React.FC<FCProps> = observer(({}) => {
  const currentStepData = CategoryKeywordModel.getCurrentStepData;

  let component = null;

  if (currentStepData?.step === 'Areas') {
    component = <AreasStep stepData={currentStepData.data} />;
  }

  if (currentStepData?.step === 'Activities') {
    component = <ActivitiesStep stepData={currentStepData.data} />;
  }

  if (currentStepData?.step === 'ActivityAreas') {
    component = (
      <ActivityAreasStep
        key={currentStepData.data.activityWithAreas.id}
        stepData={currentStepData.data}
      />
    );
  }

  if (currentStepData?.step === 'KeywordsOfTheMainCategory') {
    component = (
      <KeywordsStep
        key={currentStepData.data.keywordEntity.id}
        stepData={currentStepData.data}
      />
    );
  }

  if (
    currentStepData?.step === 'AreaKeywords' ||
    currentStepData?.step === 'ActivityWithoutAreasKeywords'
  ) {
    component = (
      <KeywordsStep
        key={currentStepData.data.keywordEntity.id}
        stepData={currentStepData.data}
      />
    );
  }

  if (currentStepData?.step === 'KeywordsActivityAreas') {
    component = (
      <KeywordsActivityAreasStep
        key={currentStepData.data.firstAreaWithNoKeywordsProvided.id}
        stepData={currentStepData.data}
      />
    );
  }

  return <div>{component}</div>;
});

export default StepRender;
